<template>
    <div class="table_wrap">
        <el-table :data="pointData"
                  class="list-table"
                  header-cell-class-name="list-header"
                  empty-text="데이터가 없습니다."
                  height="695"
        >
            <el-table-column
                class="table_no"
                type="index"
                label="No"
                width="90"
                class-name="num text-center"
                :index="tableIdx"
            >
            </el-table-column>
            <el-table-column width="" label="결제번호" prop="p_uuid" class-name="text-center"></el-table-column>
            <el-table-column min-width="" label="아이디" prop="mb_id" class-name="text-center"></el-table-column>
            <el-table-column min-width="" label="결제금액" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnCommas(scope.row.ExtraData[0].o_price_org)}}M(￦{{returnCommas(scope.row.ExtraData[0].o_price_org * 10)}})
                    </span>
                </template>
            </el-table-column>
            <el-table-column min-width="" label="결제방식" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnChargeType(scope.row.ExtraData[0].o_payment)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="결제일" width="" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ returnDateFormat(scope.row.created_at,'YYYY-MM-DD HH:mm') }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="충전취소" width="" class-name="text-center">
                <template slot-scope="scope">
                    <span v-if="scope.row.ExtraData[0].o_status === 100">충전취소완료</span>
                    <el-button class="com_btn" v-else-if="returnDifferenceDay(scope.row.created_at,7)"
                    @click="cancelCharge(scope.row.p_idx)"> 충전취소 </el-button>
                    <span v-else>-</span>
                </template>
            </el-table-column>
        </el-table>

    </div>

</template>

<script>
import dateMixins from "@/mixins/dateMixins";
import alertMixins from "@/mixins/alertMixins";
import {paymentType} from "@/service/pointService";
import util from "@/mixins/util";
import commonOptions from "@/mixins/commonOptions";
import EventBus from "@/utils/event-bus";
export default {
  name: "PointListDefaultLayout",
    mixins: [dateMixins, alertMixins,commonOptions],
  components: {
  },
  inject: ['setPage','setFilter'],
  provide() {
    return{

    }
  },
  props: {
      pointType: '',
      pointData: {
          default: () => {
              return []
          }
      },
      paginationData: {
          default: () => {
              return {total: 0, page: 0, size: 0,}
          }
      },
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
      returnDate(date = null) {
          if (!date) {
              return '';
          }
          return this.$moment(date).format('YYYY-MM-DD HH:mm')
      },
      tableIdx(index) {
          return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
      },
      returnChargeType(value){
          let keys = Object.keys(paymentType)
          let key = keys.filter(status => Number(status) === value);
          if(util.isEmpty(key)){
              return '-'
          }
          return paymentType[key].name
      },
      returnPoint(pointHistory, point){
          return pointHistory + point;
      },
      returnPlus(point){
          if(point > 0){
              point = "+"+point;
              return point;
          }else{
              return point;
          }
      },
      cancelCharge(idx){
          this.createConfirm({
              content:'충전을 취소하시겠습니까?',
              confirm:()=>{
                EventBus.$emit('cancelCharge',idx)
              }
          })
      }
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
